import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormsModule, ReactiveFormsModule, FormControl } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { EquipmentService } from '../../../../services/equipment/equipment.service'
import { CommonModule } from '@angular/common';
import { Store } from '@ngrx/store';
import { clearEquipmentData, storeEquipmentData } from '../../../../store/equipment/equipment.actions';
import { HttpRequestService } from '../../../../utilities/http/request.utilities';
import { environment } from '../../../../../environments/environment';
import {BehaviorSubject, lastValueFrom} from 'rxjs';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { LoadingComponent } from '../../../generic/loading/loading.component';
import { ButtonComponent } from '../../../generic/button/button.component';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { Equipment } from '../../../../store/equipment/equipment.model';
import { MatDialog } from '@angular/material/dialog';
import { HttpClient } from '@angular/common/http';
import { LocalForageUtilities } from '../../../../utilities/browser/localForage.utilities';

type OptionsConfig = {
  loading: BehaviorSubject<boolean>;
  error: BehaviorSubject<boolean>;
  enabled: BehaviorSubject<boolean>;
  data: BehaviorSubject<string[]>;
  label: BehaviorSubject<string>;
  filter: FormControl;
};

interface OptionsPresets {
  make: OptionsConfig;
  model: OptionsConfig;
  manualType: OptionsConfig;
  serialNumberRange: OptionsConfig;
  pvc: OptionsConfig;
}

const optionsPresets: OptionsPresets = {
  make: {
    loading: new BehaviorSubject(false),
    error: new BehaviorSubject(false),
    enabled: new BehaviorSubject(false),
    data: new BehaviorSubject<string[]>([]),
    label: new BehaviorSubject('Make'),
    filter: new FormControl('')
  },
  model: {
    loading: new BehaviorSubject(false),
    error: new BehaviorSubject(false),
    enabled: new BehaviorSubject(false),
    data: new BehaviorSubject<string[]>([]),
    label: new BehaviorSubject('Model'),
    filter: new FormControl('')
  },
    manualType: {
    loading: new BehaviorSubject(false),
    error: new BehaviorSubject(false),
    enabled: new BehaviorSubject(false),
    data: new BehaviorSubject<string[]>([]),
    label: new BehaviorSubject('Manual Types'),
    filter: new FormControl('')
  },
  serialNumberRange: {
    loading: new BehaviorSubject(false),
    error: new BehaviorSubject(false),
    enabled: new BehaviorSubject(false),
    data: new BehaviorSubject<string[]>([]),
    label: new BehaviorSubject('Serial Number Range'),
    filter: new FormControl('')
  },
  pvc: {
    loading: new BehaviorSubject(false),
    error: new BehaviorSubject(false),
    enabled: new BehaviorSubject(false),
    data: new BehaviorSubject<string[]>([]),
    label: new BehaviorSubject('PVC'),
    filter: new FormControl('')
  },
};
@Component({
  selector: 'app-home',
  standalone: true,
  imports: [
    MatCardModule,
    MatFormFieldModule,
    MatIconModule,
    MatSelectModule,
    CommonModule,
    MatInputModule,
    LoadingComponent,
    MatProgressSpinnerModule,
    FormsModule,
    ReactiveFormsModule,
    NgxMatSelectSearchModule,
    ButtonComponent
  ],
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
})
export class HomeComponent implements OnInit {
  pvcMakes: string[] = []; //Will contain the pvc makes returned by makes API
  optionsStatus: OptionsPresets = { ...optionsPresets };
  loading = new BehaviorSubject<boolean>(false);
  error = new BehaviorSubject<boolean>(false);
  wrongEquipmentId = new BehaviorSubject<boolean>(false);
  
  backendErrorMessage = new BehaviorSubject<string>('');

  equipmentId: string | null = null;
  manualDownloadSuccess: boolean | true = true;
  selectedOptions: Record<string, string | null> = {
    make: null,
    model: null,
    manualType: null,
    serialNumberRange: null,
    pvc: null
  };
  hasPdf = true;
  hasPdfByMake = true;
  showSerialNumberRange = true;
  showPVC = true;
  manualType = null; 
  serialNumberRange: string | null = null;
  
  optionsTypes = ['make', 'model', 'manualType','serialNumberRange', 'pvc'] as const;
  constructor(private router: Router, private store: Store, private httpRequestService: HttpRequestService, private http: HttpClient, private localForage: LocalForageUtilities,
  private dialog: MatDialog, private sharedData: EquipmentService
  ) {}

  ngOnInit(): void {
    this.loadOptions('make');
  }

  getFilteredOptions(optionType: keyof OptionsPresets): string[] {
    if (this.optionsStatus[optionType].data.value) {
      const selectedOptions = this.optionsStatus[optionType].data.value.filter(option => option.toLowerCase().includes(this.optionsStatus[optionType].filter.value.toLowerCase()));
      if(optionType == 'serialNumberRange'
        && selectedOptions.length > 0
        && this.selectedOptions['serialNumberRange'] == null || undefined){
        this.selectedOptions[optionType] = selectedOptions[0];
      }
         if(optionType == 'pvc'
        && selectedOptions.length > 0
        && this.selectedOptions['pvc'] == null || undefined){
        this.selectedOptions[optionType] = selectedOptions[0];
      }
  
      return selectedOptions;
    }
    return this.optionsStatus[optionType].data.value;
  }
  validateEquipmentId(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    inputElement.value = inputElement.value.toUpperCase()
    this.equipmentId = inputElement.value.replace(/[^a-zA-Z0-9]/g, '');
  }

  selectOption(optionType: keyof OptionsPresets, value: string): void {
    this.selectedOptions[optionType] = value;
    this.resetOptionsBelow(optionType);
    this.loadOptionsForNextOptionType(optionType);

    if (optionType === 'make') {
      this.hasPdf = true;
      this.hasPdfByMake = true;
      this.wrongEquipmentId.next(false);
      this.error.next(false);
    }
    // Check to see if the selected make in tech view is in pvcMakes
      if (optionType === 'manualType' && this.pvcMakes.includes((this.selectedOptions['make'] != null ? this.selectedOptions['make'] : ''))) {
        this.showSerialNumberRange = true;
        this.showPVC = true;
      }
 
// User can select either serial number range or pvc, not both, but initially both are enabled for pvc make and model
    // Check to see if the selected make in tech view is in pvcMakes
    if (this.pvcMakes.includes((this.selectedOptions['make'] != null ? this.selectedOptions['make'] : '')) && this.selectedOptions['manualType'] ) {
      if (optionType === 'pvc') { 
        // if user selects pvc, we want to reset serial number range, and sno display = false
        this.optionsStatus['serialNumberRange'].enabled.next(false);
        this.selectedOptions['serialNumberRange'] = null;
        this.showSerialNumberRange = false;
      } else if (optionType === 'serialNumberRange') {
        // if user selects serial number range, we want to reset pvc, and pvc display = false
        this.optionsStatus['pvc'].enabled.next(false);
        this.selectedOptions['pvc'] = null;
        this.showPVC = false;
      }
    }
  }


  isFormValid(): boolean {
    return (!!this.equipmentId || ((this.selectedOptions['make'] !== null) && (this.selectedOptions['model'] !== null) && ((this.selectedOptions['serialNumberRange'] !== null) || (this.selectedOptions['pvc'] !== null)) || (this.selectedOptions['manualType'] !== null))) ;
  }

  async searchEquipment(): Promise<void> {
    this.loading.next(true);
    this.error.next(false);
    this.wrongEquipmentId.next(false);
    this.hasPdf = true;
    this.hasPdfByMake = true;

    const equipmentResponse = await this.fetchEquipmentData();
    if (!equipmentResponse) {
      this.loading.next(false);
      this.equipmentId = null;
      return this.error.next(true);
    }
    this.store.dispatch(clearEquipmentData());
    console.log('Selected Options:', this.selectedOptions); ////////////////////
    const equipmentData = this.mapEquipmentData(equipmentResponse);
    const resources = await Promise.all(
      equipmentData.resources.map(resource => this.fetchDownloadUrl(resource.providerResourceUrl || ''))
    );
    const equipment = {
      ...equipmentData,
      resources: equipmentData.resources.map((resource, index) =>
        ({ ...resource, downloadUrl: resources[index].downloadUrl, s3Key: resources[index].s3Key }))
    };

    const pdfResponse = equipment.resources.some(resource =>
      resource.s3Key && resource.s3Key.endsWith('.pdf') 
    );

    const pdfResources = resources.filter(resource =>
      resource.downloadUrl && resource.downloadUrl.length > 0
    );

    await this.localForage.cleanupExpired();

    const maxSafeSizeInMB = 10;
    for (const resource of pdfResources) {
      const pdfUrl = resource.downloadUrl;
      const pdfName = new URL(pdfUrl).pathname;

      try {
        // Check file size first using HEAD request
        const headResponse = await lastValueFrom(
          this.http.head(pdfUrl, { observe: 'response' })
        );

        const contentLength = headResponse.headers.get('content-length');
        const fileSizeMB = contentLength ? parseInt(contentLength, 10) / (1024 * 1024) : 0;

        // Only download if file size is under the limit
        if (fileSizeMB < maxSafeSizeInMB) {
          const blob = await lastValueFrom(this.http.get(pdfUrl, { responseType: 'blob' }));
          await this.localForage.set(pdfName, blob, 1000 * 60 * 60 * 4); // 4 hours
        }
      } catch (error) {
        console.error('Error handling PDF:', error);
      }
    }

    if (equipment.details.serialNumberRange){
      this.hasPdfByMake = false;
    }else {
      this.hasPdf = false;
    }

    if (equipment.details.serialNumberRange){
      this.hasPdfByMake = false;
    } else {
      this.hasPdf = false;
    }

    this.store.dispatch(storeEquipmentData({ equipment }));
    this.loading.next(false);

    if (!pdfResponse) {
      return;
    }

    this.router.navigate(['/technician/equipment']);
  }

  private fetchDownloadUrl(providerResourceUrl: string): Promise<{ downloadUrl: string, s3Key: string }> {
    const sanitizedUrl = providerResourceUrl.replace(/;/g, '%3B');
    return new Promise((resolve) => {
      this.httpRequestService.request<any>('GET', sanitizedUrl).subscribe({
        next: (response) => {
          resolve({ downloadUrl: response.download_url, s3Key: response.s3_key });
        },
        error: (error) => {
          console.error(`Error fetching download URL: ${error.status}`, error);
          if (error.status === 404) {
            this.error.next(true);
            this.loading.next(false);
            resolve({ downloadUrl: '', s3Key: '' });
          } else {
            resolve({ downloadUrl: '', s3Key: '' });
          }
        }
      });
    });
  }

  private resetOptionsBelow(currentOptionType: keyof OptionsPresets): void {
    const currentIndex = this.optionsTypes.indexOf(currentOptionType);
    this.optionsTypes.slice(currentIndex + 1).forEach(option => {
      if (option === 'manualType' && currentOptionType !== 'make' && currentOptionType !== 'model') {
      // Don't reset manualType unless make/model changed
      return;
    }
      this.optionsStatus[option].enabled.next(false);
      this.optionsStatus[option].data.next([]);
      this.selectedOptions[option] = null;
    });

    // Check to see if pvc search is enabled for selected make
    if (this.pvcMakes.includes((this.selectedOptions['make'] != null ? this.selectedOptions['make'] : '')) && this.selectedOptions['manualType']) {
      this.optionsStatus['pvc'].enabled.next(true);
      this.optionsStatus['serialNumberRange'].enabled.next(true);
    }
  }

  private mapEquipmentData(equipmentResponse: any): Equipment {
    const prompts = equipmentResponse?.PROMPTS?.resources?.map((resource: { prompt: string }) => resource.prompt) || [
      'Boom will not lower',
      '01925 error code',
      'What does DCT 0033 mean?',
      'Check parts manual',
      'Turn table is not centered',
    ];

    const resources = equipmentResponse?.PDF_Link?.resources?.map((resource: { title: string, url: string }) => {
      if (!resource.url.endsWith('.pdf')) {
        return [];
      }
      const fileName = resource.url.split('/').pop()?? '';
      const manualType = resource.url.split('/').slice(-2, -1)[0];
      const documentMake = resource.url.split('/').slice(-3, -2)[0];
      const providerResourceUrl = `${environment.integrations.manualDownload}?equipment_make=${documentMake}&file_name=${encodeURIComponent(fileName)}&manual_type=${manualType}`;
      this.manualDownloadSuccess = false;
      return {
        title: resource.title,
        url: resource.url,
        downloadUrl: '',
        s3Key: '',
        providerResourceUrl: providerResourceUrl
      };
    }) || [];
    return {
      details: {
        id: equipmentResponse.EQUIPMENT_CODE,
        make: equipmentResponse.MAKE,
        model: equipmentResponse.MODEL,
        serialNumberRange: equipmentResponse.EQUIPMENT_SERIAL_RANGE,
        pvc: equipmentResponse.PVC,
        // manualType: equipmentResponse.MANUAL_TYPE,
        equipmentCode: equipmentResponse.EQUIPMENT_CODE
      },
      resources,
      prompts
    }
  }

  private loadOptionsForNextOptionType(currentOptionType: keyof OptionsPresets): void {
    if (currentOptionType === 'manualType') {
      this.optionsStatus['serialNumberRange'].enabled.next(true);
      this.loadOptions('serialNumberRange');
       this.showSerialNumberRange = true;
       
       // Check to see if pvc search is enabled for selected make
       if(this.pvcMakes.includes((this.selectedOptions['make'] != null ? this.selectedOptions['make'] : ''))) {
        this.optionsStatus['pvc'].enabled.next(true);
        this.loadOptions('pvc');
      }
      return;
    }

    const nextOptionType = this.getNextOptionType(currentOptionType);
    if (nextOptionType) {
      this.loadOptions(nextOptionType);
    }
  }

  private getNextOptionType(currentOptionType: keyof OptionsPresets): keyof OptionsPresets | null {
    const currentIndex = this.optionsTypes.indexOf(currentOptionType);
    if(currentOptionType)
    if (currentOptionType === 'manualType' && this.pvcMakes.includes((this.selectedOptions['make'] != null ? this.selectedOptions['make'] : ''))) {
      return 'pvc';
    }
    if (currentOptionType === 'manualType' && this.pvcMakes.includes((this.selectedOptions['make'] != null ? this.selectedOptions['make'] : ''))) {
      return 'serialNumberRange';
    }
    return currentIndex < this.optionsTypes.length - 1 ? this.optionsTypes[currentIndex + 1] : null;
  }

  private async loadOptions(optionType: keyof OptionsPresets): Promise<void> {
    const option = this.optionsStatus[optionType];
    option.loading.next(true);
    option.label.next('Loading...');
    const urlParams = new URLSearchParams();
    const endpoint = this.determineEndpoint(optionType, urlParams);
    if (endpoint) {
      try {
        await this.fetchOptionData(endpoint, urlParams, optionType);
      } catch (error) {
        console.error(`Failed to load ${option.label.value} options`, error);
      }
    }
  }

  private determineEndpoint(optionType: keyof OptionsPresets, urlParams: URLSearchParams): string {
    switch (optionType) {
      case 'make':
        return environment.integrations.make;
      case 'model':
        if (this.selectedOptions['make']) {
          urlParams.append('make', this.selectedOptions['make']);
          return environment.integrations.model;
        }
        break;
      case 'serialNumberRange':
        if (this.selectedOptions['model'] && this.selectedOptions['make']) {
          urlParams.append('make', this.selectedOptions['make'] as string);
          urlParams.append('model', this.selectedOptions['model'] as string);
          if (this.selectedOptions['manualType']!='All Manuals' && this.selectedOptions['manualType']) {
            urlParams.append('manualType', this.selectedOptions['manualType'] as string);
          }

          return environment.integrations.serialNumberRange;
        }
        break;
      case 'pvc':
        if (this.selectedOptions['model'] && this.selectedOptions['make']) {
          urlParams.append('make', this.selectedOptions['make'] as string);
          urlParams.append('model', this.selectedOptions['model'] as string);
           if (this.selectedOptions['manualType']!='All Manuals' && this.selectedOptions['manualType']) {
            urlParams.append('manualType', this.selectedOptions['manualType'] as string);
          }

          return environment.integrations.pvc;
        }
        break;
      case 'manualType':
         if (this.selectedOptions['model'] && this.selectedOptions['make']) {
          urlParams.append('make', this.selectedOptions['make'] as string);
          urlParams.append('model', this.selectedOptions['model'] as string);
        return environment.integrations.manualType;
    }
    break;
  }
    return '';
  }

  private formatOptionLabel(optionType: keyof OptionsPresets): string {
    if (optionType === 'serialNumberRange') return 'Serial Number Range';
    if (optionType === 'manualType' && !this.selectedOptions['manualType']) return 'Manual Types';
    if (optionType === 'manualType') return 'Manual Type';
    return optionType.charAt(0).toUpperCase() + optionType.slice(1);
  }

  private async fetchOptionData(endpoint: string, urlParams: URLSearchParams, optionType: keyof OptionsPresets): Promise<void> {
    return new Promise((resolve, reject) => {
      this.httpRequestService.request<any>('GET', `${endpoint}?${urlParams}`).subscribe({
        next: (response) => this.updateOptionStatus(response, optionType, resolve),
        error: (error) => this.handleOptionError(error, optionType, reject)
      });
    });
  }

  private updateOptionStatus(response: any, optionType: keyof OptionsPresets, resolve: (value: void | PromiseLike<void>) => void): void {
    const data = this.updateOptionData(response, optionType);
    this.optionsStatus[optionType].data.next(data);
    this.optionsStatus[optionType].loading.next(false);
    this.optionsStatus[optionType].error.next(false);
    this.optionsStatus[optionType].enabled.next(true);
    this.optionsStatus[optionType].label.next(this.formatOptionLabel(optionType));

    if (optionType === 'manualType' && this.selectedOptions['model'] && !this.selectedOptions['manualType']) {
        this.selectedOptions['manualType'] = 'All Manuals'; // default value for manualType
        this.selectOption('manualType', 'All Manuals');
      }

    resolve();
  }

  private handleOptionError(error: any, optionType: keyof OptionsPresets, reject: (reason?: any) => void): void {
    console.error(`Failed to load ${this.optionsStatus[optionType].label.value} options`, error);
    
    const errorMessage = error?.error?.body?.message || 
                      error?.error?.detail || 
                      `Failed to load ${this.formatOptionLabel(optionType)} options. Please try again.`;
  this.backendErrorMessage.next(errorMessage);

    this.optionsStatus[optionType].error.next(true);
    this.optionsStatus[optionType].loading.next(false);
    this.optionsStatus[optionType].enabled.next(true);
    this.optionsStatus[optionType].label.next(this.formatOptionLabel(optionType));
    reject(error);
  }

  private updateOptionData(response: any, optionType: keyof OptionsPresets): any {
    switch (optionType) {
      case 'make':
        // After the make API call, save the PVC makes and set the values
        this.pvcMakes = response.pvc_makes;
        this.sharedData.setValue(this.pvcMakes);
        return response.makes || [];
      case 'model':
        return response.models || [];
      case 'serialNumberRange':
        return response.serial_ranges
          ? response.serial_ranges
              .filter((range: { StartSerial: string, EndSerial: string }) =>
                range.StartSerial && range.EndSerial && range.StartSerial !== 'nan' && range.EndSerial !== 'nan'
              )
              .map((range: { StartSerial: string, EndSerial: string }) => `${range.StartSerial} - ${range.EndSerial}`)
          : [];
      case 'pvc':
        return response.pvcs
        ? response.pvcs.map((pvc: string) => pvc.endsWith('.0') ? pvc.replace('.0', '') : pvc)
        : [];
      case 'manualType':
        return response.manual_types || [];

    }
  }

  private getEquipmentUrl(): { url: string, params: URLSearchParams } {
    const params = new URLSearchParams();
    const url = this.determineUrlBasedOnOptions(params);

    return { url, params };
  }

  private determineUrlBasedOnOptions(params: URLSearchParams): string {
    if (this.equipmentId && this.manualDownloadSuccess) {
      params.append('equipment_code', this.equipmentId);
      return environment.integrations.equipmentByCode;
    } else if (this.selectedOptions['make'] && this.selectedOptions['model']) {
      params.append('make', this.selectedOptions['make']);
      params.append('model', this.selectedOptions['model']);
      
    //<---------------------------------------- Future functionality, leave as is -------------------------------->
    // Only append manual_type if not 'All Manuals'
    // if (this.selectedOptions['manualType']!='All Manuals' && this.selectedOptions['manualType']) {
    //   params.append('manualType', this.selectedOptions['manualType']);
    // }
    
      if (this.selectedOptions['serialNumberRange']) {
        const [serialNumStart, serialNumEnd] = this.selectedOptions['serialNumberRange'].split(' - ');
        params.append('serialNumStart', serialNumStart);
        params.append('serialNumEnd', serialNumEnd);
        return environment.integrations.bySerialRange;
      } else if (this.selectedOptions['pvc']) {
        params.append('pvc', `${this.selectedOptions['pvc']}`);
        return environment.integrations.byPvc;
      }
    }
    // Default to equipmentByCode if other conditions fail
    params.append('equipment_code', this.equipmentId || '');
    return environment.integrations.equipmentByCode;
  }

  private async fetchEquipmentData(): Promise<any> {
    const { url, params } = this.getEquipmentUrl();
    const prompts_url = environment.integrations.prompts;

    try {
      return await new Promise((resolve, reject) => {
        // Make the API call to fetch the manual
        this.httpRequestService.request('GET', `${url}?${params.toString()}`).subscribe({
          next: (firstResponse) => {
            //console.log('This is what we got from API 1 ', firstResponse)
            params.append("make",(firstResponse as any).MAKE)
            params.append("model",(firstResponse as any).MODEL)
            // Make the API call to get the equipments prompts
            this.httpRequestService.request('GET', `${prompts_url}?${params.toString()}`).subscribe({
              next: (secondResponse) => {
                // console.log('This is what we got from API 2 ', secondResponse)
                if(url.includes('manual-by-code')){
                  const output_dict = {
                    "equipment": {
                      "PDF_Link":(firstResponse as any).PDF_Link,
                      'PROMPTS':(secondResponse as any).PROMPTS,
                      "MAKE_MODEL": (firstResponse as any).MAKE_MODEL,
                      "MAKE": (firstResponse as any).MAKE,
                      // "PVC": (firstResponse as any).PVC, We can possibly keep this
                      "EQUIPMENT_SERIAL_NUM": (firstResponse as any).EQUIPMENT_SERIAL_NUM,
                      "MODEL": (firstResponse as any).MODEL,
                      "EQUIPMENT_CODE":(firstResponse as any).EQUIPMENT_CODE,
                      "EQUIPMENT_TYPE_DESC": (firstResponse as any).EQUIPMENT_TYPE_DESC
                    }
                  }
                  //console.log('This is what we are returning ', output_dict)
                  // Resolve with a dictionary containing both responses
                  resolve(output_dict.equipment);
                }
                else{
                  const output_dict = {
                    "equipment": {
                      "PDF_Link":(firstResponse as any).PDF_Link,
                      'PROMPTS':(secondResponse as any).PROMPTS,
                      "MAKE_MODEL": (firstResponse as any).MAKE_MODEL,
                      "MAKE": (firstResponse as any).MAKE,
                      "PVC": (firstResponse as any).PVC,
                      "EQUIPMENT_SERIAL_RANGE": (firstResponse as any).EQUIPMENT_SERIAL_RANGE,
                      "MODEL": (firstResponse as any).MODEL,
                    }
                  }
                  //console.log('This is what we are returning ', output_dict)
                  // Resolve with a dictionary containing both responses
                  resolve(output_dict.equipment);
                }
              },
              error: (secondError) => {
                // Handle second API call error
                this.loading.next(false);
                   const errorMessage = secondError?.error?.body?.message || 
                                 secondError?.error?.detail || 
                                 'An error occurred while fetching equipment data.';
              this.backendErrorMessage.next(errorMessage);
                reject(secondError);
              }
            });
          },
          error: (firstError) => {
            // Handle first API call error
            if (firstError.status === 404 || (firstError.error?.detail && firstError.error.detail.includes('No equipment found'))) {
              this.wrongEquipmentId.next(true);
              this.error.next(true);
            // Extract the specific error message from backend
            const errorMessage = firstError?.error?.body?.message || 
                                firstError?.error?.message || 
                                firstError?.error?.detail ||
                                'Invalid equipment code. The Equipment you are searching for does not match our current records. Please try again.';
            this.backendErrorMessage.next(errorMessage);
            
              resolve(null);
            } else {
              this.loading.next(false);
              const errorMessage = firstError?.error?.body?.message || 
                                firstError?.error?.detail || 
                                'An unexpected error occurred. Please try again.';
            this.backendErrorMessage.next(errorMessage);
              reject(firstError);
            }
          }
        });
      });
    } catch (error) {
      this.error.next(true);
      this.wrongEquipmentId.next(false);
      this.loading.next(false);
      return null;
    }
  }
}
